import React from 'react';
import SelectionList, { SelectionListItem } from './SelectionList';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedSystem, Steps } from '../../Reducers/App/Selectors';
import { setCurrentStep, setSelectedSystem, setSelectedProductType } from '../../Reducers/App/Actions';

interface SystemSelectorProps {
  title: string;
  items: SelectionListItem[];
}
const SystemSelector: React.FC<SystemSelectorProps> = (props) => {
  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(setCurrentStep(Steps.PRODUCT_TYPE_SELECT));
    dispatch(setSelectedSystem(item));
    dispatch(setSelectedProductType(null));
  };

  const selectedItem = useSelector(getSelectedSystem);

  return (
    <SelectionList
      items={props.items}
      title={props.title}
      onItemSelection={handleClick}
      selectedItem={selectedItem}
    />
  );
};

export default SystemSelector;
